// Export lib/mongule
module.exports = require('./lib/Stopwatch');